// The checkout button is hidden by default so we only show it
// once the appropiate event handlers are attached to it
export function showCheckoutButton() {
  $('.js-checkout-button').removeClass('d-none');
  $('.js-checkout-button').addClass('d-flex');
}
